import { Directive, Input } from '@angular/core';
import type { LegacyFrontendWidgetConfig } from '../../interfaces/Widget.interface';
import { WidgetSize } from '../../providers/widgets.contants';

@Directive()
export abstract class AbstractWidgetClass<T extends string | null, WidgetSettings> {
    @Input() config!: LegacyFrontendWidgetConfig<T, WidgetSettings>;

    readonly size: WidgetSize = WidgetSize.HALF;
}
